import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { AppStore } from './infraestructure/store';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import '@seafile/react-image-lightbox/style.css';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick-theme.css';
import 'react-tabs-scrollable/dist/rts.css';

import { BrandProvider } from './core/contexts/BrandContext';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Failed to find the root element');
}

createRoot(rootElement).render(
  <BrowserRouter>
    <Provider store={AppStore.instance}>
      <BrandProvider>
        <App />
      </BrandProvider>
    </Provider>
  </BrowserRouter>
);

reportWebVitals();
